// src/components/ContentViews/MapShow.js
import React, { useEffect } from 'react';

let isMapKitInitialized = false;

const MapShow = React.forwardRef(({ poiCategory = 'Cafe' }, ref) => {

  useEffect(() => {
    if (!isMapKitInitialized && window.mapkit) {
      window.mapkit.init({
        authorizationCallback: (done) => {
          done(process.env.REACT_APP_MAPKIT_JS_TOKEN);
        },
      });
      isMapKitInitialized = true;
    }

    if (window.mapkit && ref && !ref.current) {
      const mapkit = window.mapkit;
      const map = new mapkit.Map('mapContainer');
      ref.current = map;

      map.showsUserLocation = true;
      map.showsCompass = mapkit.FeatureVisibility.Visible;
      map.isRotationEnabled = true;
      map.showsScale = mapkit.FeatureVisibility.Visible;
      map.padding = new mapkit.Padding({ top: 0, right: 10, bottom: 5, left: 10 });

      const searchNearbyPOI = (coordinate) => {
        const span = new mapkit.CoordinateSpan(0.01, 0.01);
        const region = new mapkit.CoordinateRegion(coordinate, span);

        // Determine the correct category based on the `poiCategory` prop
        const poiFilter = mapkit.PointOfInterestFilter.including([
          mapkit.PointOfInterestCategory[poiCategory] || mapkit.PointOfInterestCategory.Cafe
        ]);

        const poiSearch = new mapkit.Search({
          region,
          regionPriority: mapkit.Search.RegionPriority.Required,
          pointOfInterestFilter: poiFilter,
        });

        poiSearch.search(poiCategory, (error, results) => {
          if (error || !results.places || results.places.length === 0) {
            console.error(`No ${poiCategory.toLowerCase()} found nearby or search error:`, error);
            return;
          }

          map.removeAnnotations(map.annotations);

          let count = 0;
          results.places.forEach((place) => {
            if (count++ >= 5) return; // Limit to 5 POIs
            const annotation = new mapkit.PlaceAnnotation(place);
            const accessory = new mapkit.PlaceSelectionAccessory();
            annotation.selectionAccessory = accessory;
            annotation.title = place.name;
            
            const geocoder = new mapkit.Geocoder({ language: 'en-US' });
            geocoder.reverseLookup(place.coordinate, (error, data) => {
              const address = data?.results?.[0]?.formattedAddress || 'Unknown Location';
              annotation.subtitle = address; // Set subtitle as address
            });

            map.addAnnotation(annotation);
            // print count and place name to console
            console.log(`${poiCategory} ${count}:`, place);
          });
        });
      };

      map.addEventListener('single-tap', (event) => {
        const coordinate = map.convertPointOnPageToCoordinate(event.pointOnPage);
        searchNearbyPOI(coordinate);
      });
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener('single-tap');
        ref.current.destroy();
        ref.current = null;
      }
    };
  }, [ref, poiCategory]);

  return null;
});

export default MapShow;
